var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collapse-bar position",on:{"click":_vm.handleClick}},[(_vm.position === 'right')?_c('el-icon',{class:_vm.show? 'el-icon-arrow-right': 'el-icon-arrow-left'}):_c('el-icon',{class:_vm.show? 'el-icon-arrow-left': 'el-icon-arrow-right'})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }